export const mobile = 480;
export const tablet = 768;
export const desktop = 1000;
